import {
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	createCrudService,
	keyToUrl,
	withUsagesEndpoint,
} from "@dgs/core";
import axios from "axios";
import { CostCategoryOptionResource } from "../../../../shared/types/costCategory";
import { EventCostCategoryIndexResource } from "../../../../shared/types/event";
import { CostCategoryIndexResource, CostCategorySaveRequest, CostCategoryUpdateResource } from "../types/costCategory";

const baseKey = ["cost-categories"];
const indexByEventKey = (eventId: Id) => ["events", `${eventId}`, "cost-categories"];

export const costCategoryService = {
	...createCrudService<
		CostCategoryIndexResource,
		CostCategoryOptionResource,
		CostCategoryUpdateResource,
		CostCategorySaveRequest
	>(baseKey),
	...withUsagesEndpoint(baseKey),
	indexByEventKey,
	indexByEvent: (config: PaginatedListFetcherConfig<EventCostCategoryIndexResource>, eventId: Id) =>
		axios.get<LaravelResponse<EventCostCategoryIndexResource[]>>(keyToUrl(indexByEventKey(eventId)), {
			params: { ...config.searchParams, ...config.pageParams },
		}),
};
